<template>
  <div v-if="kind === 'loading'" class="ui-card rd-card rd-loading" role="status" aria-busy="true">
    <span class="rd-visually-hidden">{{ $t("loading") }}</span>
    <div
      v-for="line in rows"
      :key="line"
      class="rd-skeleton"
      :style="{ height: line === 1 ? '36px' : '28px', width: `${100 - ((line * 9) % 31)}%` }"
    ></div>
  </div>

  <div v-else-if="kind === 'error'" class="rd-alert ui-banner ui-banner--lg" role="alert">
    <v-icon size="22" color="#7a1b13">mdi-alert-outline</v-icon>
    <div>
      <b>{{ title || $t("report_mobile.load_failed") }}</b>
      <span v-if="text">{{ text }}</span>
      <button type="button" class="ui-btn ui-btn--sm rd-state__retry" @click="$emit('retry')">
        <v-icon size="16">mdi-refresh</v-icon>
        {{ $t("report_mobile.retry") }}
      </button>
    </div>
  </div>

  <div v-else class="ui-card rd-card">
    <div class="rd-empty">
      <div class="rd-empty__ring">
        <v-icon size="30">{{ icon }}</v-icon>
      </div>
      <b>{{ title }}</b>
      <span v-if="text">{{ text }}</span>
      <slot></slot>
    </div>
  </div>
</template>

<script>
/** Stanja izveštaja: učitava (skelet), greška (sa "Pokušaj ponovo") i prazno (sa predlogom). */
export default {
  name: "ReportState",
  props: {
    kind: {
      type: String,
      default: "empty",
      validator: (value) => ["loading", "error", "empty"].includes(value),
    },
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mdi-tray-remove",
    },
    rows: {
      type: Number,
      default: 7,
    },
  },
};
</script>
